import React, {useEffect} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { BlackMask } from "../../../../components/mask/index"
import { useState } from 'react'
import MeChildHeader from '../../components/me-child-header'
import SettingList from './components/setting-list'
import { useSelector } from 'react-redux'
import { BigButton } from '../../../../components/button'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { action_fetch_currencies, action_logout, action_set_currency, setLanguage } from '../../../../../store/actions/global'
import MeLoading from '../../components/loading'
import LanguageList from './components/language-list'
import Cookies from 'js-cookie'
import { FormattedMessage, useIntl } from 'react-intl'
import CurrencyList from './components/currency-list'
import { useParams } from 'react-router-dom'
import { useStore } from 'react-redux'
import { useQuery } from '../../../../hooks/common'
import Alert from '../../../../components/alert'


const Settings = props => {
    useStyles(classes);
    const global = useSelector(state => state.global)
    const {currency, currencies, language, languages, user, config} = global || {}
    const dispatch = useDispatch()
    const Intl = useIntl()

    const store = useStore()
    const params = useParams()
    const query = useQuery()

    const [showLang, setShowLang] = useState(false)
    const [showCurrency, setShowCurrency] = useState(false)
    const [loading, setLoading] = useState(true)

    const BASEURL = '/user'
    const settingList = [{
        id: 0,
        name: 'main',
        children:[
            {
                id: '0-0',
                name: Intl.formatMessage({id: 'address_book'}),
                href: BASEURL+'/address-book',
                outer: false,
            },
            {
                id: '0-1',
                name: Intl.formatMessage({id: 'my_payment_options'}),
                href: BASEURL+'/credit-cards',
                outer: false,
            },
            {
                id: '0-2',
                name: Intl.formatMessage({id: 'change_password'}),
                href: BASEURL+ '/change-password',
                outer: false,
            },
            {
                id: '0-3',
                name: Intl.formatMessage({id: 'change_email'}),
                href: BASEURL + '/change-email',
                outer: false,
            },
        ]
    },{
        id: 1,
        name: 'tools',
        children:[
            {
                id: '1-0',
                name: Intl.formatMessage({id: 'language'}),
                showLan: true,
                outer: false,
            },
            {
                id: '1-1',
                name: Intl.formatMessage({id: 'currency'}),
                showCurrency: true,
                outer: false,
            },
        ]
    },{
        id: 2,
        name: 'policy',
        children:[
            {
                id: '2-0',
                name: Intl.formatMessage({id: 'contact_us'}),
                href: '/user/support',
                outer: true,
            },
            {
                id: '2-1',
                name: Intl.formatMessage({id: 'follow_us', defaultMessage: 'Follow Us'}),
                type: 'follow_us'
            },
            {
                id: '2-2',
                name: Intl.formatMessage({id: 'about'}) + ' ' + config?.name,
                href: BASEURL + '/setting-policy',
            },
        ]
    }]

    useEffect(async () => {
        if (window.__INITIAL_STATE__) {
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		} else {
            await Settings.fetchData(store, params, query)
		}
    }, [])

    useEffect(async () => {
        if(currencies?.length > 0){
            setLoading(false)
        } else {
            await Settings.fetchData(store, params, query)
            setLoading(false)
            // setTimeout(() => {
            //     setLoading(false)
            // }, 5000)
        }
    },[currencies])

    const initLang = () => {
        if(language == "es"){
            return "Español";
        }else if(language == "de"){
            return "Deutsch";
        }else if(language == "fr"){
            return "Français";
        }else if(language == "pt"){
            return "Português";
        }else if(language == "da"){
            return "Dansk";
        }else if(language == "is"){
            return "Íslenska";
        }else if(language == "nb"){
            return "Norsk";
        }else if(language == "sv"){
            return "Svenska";
        }else if(language == "fi"){
            return "Suomalainen";
        }else{
            return "English";
        }
    }

    const onBack = () => {
        window.history.back()
    }

    const logoutHandle = useCallback(evt => {
        dispatch(action_logout()).then(response =>{
            if(response?.code === 200){
                window.location.href = '/';
            }else{
                Alert(response?.result || Intl.formatMessage({ id: "network_error", defaultMessage: "Network Error" }));
            }
        })
    }, [])

    const changeLanguage = (value) => {
        if(value != language){
            dispatch(setLanguage(value))
		    Cookies.set('lang', value, { path: '/', expires: 30 })
            const originUrl = window.location.href
            const directUrl = originUrl.replace(/\/(en|es|de|fr|pt|is|fi|sv|nb|da)\//, `/${value}/`)
            setShowLang(false)
            window.location.replace(directUrl)
        }
    }

    const changeCurrency = async (value) => {
        await dispatch(action_set_currency(value))
		Cookies.set('currency', value, { path: '/', expires: 30 })
		window.location.reload();
    }

    const showLanguageFunc = () => {
        setShowLang(true)
    }

    const showCurrencyFunc = () => {
        setShowCurrency(true)
    }

    return <div className={classes.SettingPage}>
        <MeChildHeader name={Intl.formatMessage({id: 'setting'})} onBack={() => onBack()}/>

        <SettingList list={settingList} currency={currency} language={initLang()} showLanguage={showLanguageFunc} showCurrency={showCurrencyFunc}/>

        <div className={classes.SignOutButton}>
            <BigButton onClick={logoutHandle}><FormattedMessage id="sign_out" defaultMessage="Sign Out"/></BigButton>
        </div>

        <LanguageList
            show={showLang}
            languages={languages}
            languageLocale={language}
            toChangeLanguage={(e) => changeLanguage(e)}
            onClose={() => setShowLang(false)}
            />

        <CurrencyList
            show={showCurrency}
            currencies={currencies}
            currencyLocale={currency}
            toChangeCurrency={e => changeCurrency(e)}
            onClose={() => setShowCurrency(false)}
            />

        <MeLoading loading={loading} />
    </div>
}


Settings.fetchData = async (store, params, search, headers) => {
    await store.dispatch(action_fetch_currencies(headers))
}

export default Settings
